<template>
    <div>
        <div
            v-for="partner in SkPartnersList"
            :key="partner.name"
            class="d-flex flex-shrink-1 flex-grow-0 flex-column justify-center align-center"
        >
            <NuxtLink
                :to="partner.url"
                :target="isUrl(partner.url) ? '_blank' : undefined"
                :rel="isUrl(partner.url) ? 'noopener noreferrer' : undefined"
                :aria-label="partner.label"
            >
                <v-img
                    width="240"
                    :aspect-ratio="partner.width / partner.height"
                    :src="getResourceCdnUrl(`${logoBasePath}/${partner.logoColor}`)"
                ></v-img>
            </NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { SkPartnersList } from '~/models';
    import {
        useCdnResource
    } from 'x1-base/composables';
    import { isUrl } from 'x1-base/utils';

    const logoBasePath = '/static/common/images/svg/partners';
    const { getResourceCdnUrl } = useCdnResource();
</script>

<style lang="scss" scoped></style>
